module.exports = __webpack_public_path__ + "img/COMBO RADIO 2 LIME.323a75f.svg";